
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_checklist';
const tableOfContents = [{
  "title": "5 Steps for no-code creators and builders",
  "slug": "5-steps-for-no-code-creators-and-builders",
  "children": [{
    "title": "Advanced Informations",
    "slug": "advanced-informations",
    "children": []
  }, {
    "title": "A. UI Customisation via Editor",
    "slug": "a-ui-customisation-via-editor",
    "children": []
  }, {
    "title": "B. Platform Fundamentals",
    "slug": "b-platform-fundamentals",
    "children": []
  }, {
    "title": "C. Web Integrations",
    "slug": "c-web-integrations",
    "children": []
  }, {
    "title": "System integrations",
    "slug": "system-integrations",
    "children": []
  }]
}, {
  "title": "For developers",
  "slug": "for-developers",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Checklist from start to end on what you need to build a marketplace using Tradly Platform.`}</p>
    <p>{`Tradly Platform solution is catered to different groups separately`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`For developers: `}<a parentName="li" {...{
          "href": "https://tradly.app"
        }}>{`Headless API solution`}</a>{`. Using the API solution, developers can build apps on top of it.`}</li>
      <li parentName="ul">{`For no-code creators: A simple toggle based SuperAdmin Panel to configure features in the already pre-built apps (also called as storefront, front end apps, templated apps).`}</li>
    </ul>
    <p>{`Tradly Definition`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Listings is same as products, campaigns, items, etc. Listing has features like pricing, inventory, etc. `}</li>
      <li parentName="ul">{`Account is same as sellers, campaign owners, donors, etc. Account has features like wallet, payout, shipping preferences, etc.`}</li>
    </ul>
    <p>{`You will continue to see we use Listings and accounts in all our articles and documentations.`}</p>
    <_Heading level={2} id={"5-steps-for-no-code-creators-and-builders"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": true
    }}>5 Steps for no-code creators and builders</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://tradly.app/signup"
          }}>{`Signup for a free account`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Choose the templates (`}<a parentName="p" {...{
            "href": "https://tradly.app/templates"
          }}>{`https://tradly.app/templates`}</a>{`)`}</p>
        <img src="/img/templates.png" alt="Templates Gallery" width="600" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Do the branding customisation & business informations on `}<a parentName="p" {...{
            "href": "https://tradly.app/editor"
          }}>{`Editor`}</a></p>
      </li>
    </ol>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/new-editor.png" />
    </div>
    <ol {...{
      "start": 4,
      "role": "list"
    }}>
      <li parentName="ol">{`Launch`}</li>
    </ol>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Web App: By default when you register, you will get the production URL to use the app. And you can add custom domain. `}</li>
    </ul>
    <_Heading level={3} id={"advanced-informations"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Advanced Informations</_Heading>
    <_Heading level={3} id={"a-ui-customisation-via-editor"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>A. UI Customisation via Editor</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Global Styling (Font, Color, Padding, Gap, Buttons)`}</li>
      <li parentName="ul">{`Business Informations`}</li>
      <li parentName="ul">{`Header Customisations`}</li>
      <li parentName="ul">{`Feature Activation/Deactivation`}</li>
      <li parentName="ul">{`Footer Customisations`}</li>
    </ul>
    <_Heading level={3} id={"b-platform-fundamentals"} nextElement={{
      "type": "paragraph"
    }}>B. Platform Fundamentals</_Heading>
    <p>{`You must configure the below things for the system to be able to open accounts, submit listings and make purchases.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Configure accounts in SuperAdmin > SideMenu > Accounts(categories, attributes)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Configure listings in SuperAdmin > SideMenu > Listings(categories, attributes)`}</p>
        <div class="relative">
          <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/listing-category.png" />
        </div>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Stripe/other payment gateways configuration`}</p>
      </li>
    </ul>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/payment-method.png" />
    </div>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Configure revenue model, commissions: Settings > commissions OR Settings > Subscriptions OR Settings > Special Fees`}</li>
    </ul>
    <_Heading level={3} id={"c-web-integrations"} nextElement={{
      "type": "jsx"
    }}>C. Web Integrations</_Heading>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/webintegrations.png" />
    </div>
    <p>{`Dozens of website integrations to help you with marketing, analytics and products. `}<a parentName="p" {...{
        "href": "https://tradly.app/integrations"
      }}>{`Check here`}</a></p>
    <_Heading level={3} id={"system-integrations"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>System integrations</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Configure email if you want the emails to be whitelisted`}</li>
      <li parentName="ul">{`Configure domain if you want good deliverability of emails`}</li>
      <li parentName="ul">{`Configure Google Maps if you have location specific features`}</li>
    </ul>
    <_Heading level={2} id={"for-developers"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>For developers</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://tradly.app/signup"
        }}>{`Signup for a free account`}</a></li>
      <li parentName="ul">{`Get the API keys in the SuperAdmin > Settings > API section = Refer the `}<a parentName="li" {...{
          "href": "https://developer.tradly.app/"
        }}>{`API reference`}</a>{` to start building the app`}</li>
      <li parentName="ul">{`Optionally Fork `}<a parentName="li" {...{
          "href": "https://github.com/TRADLY-PLATFORM"
        }}>{`Open source app starter Kits`}</a></li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
